/*
 * Copyright © 2026 Bruce Matin,  ALL RIGHTS RESERVED!
 */

import axios from 'axios';

const api = axios.create({
  // You can set baseURL here if needed, e.g., baseURL: process.env.REACT_APP_API_URL
});

// Add a request interceptor to include the bearer token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle common errors (like 401 Unauthorized)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      // Redirect to login or handle as needed
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
